import type { JSX, MouseEvent } from "react";
import type { components } from "../../api/schema";
import { ModalFrame } from "../../components/ui/ModalFrame";
import { SegmentRenderer } from "./SegmentRenderer";
import type { CharacterEntry } from "./parseInlineMarkup";

type Segment = components["schemas"]["Segment"];

export type VisualNovelLogModalProps = {
  segments: readonly Segment[];
  charactersMap: Map<string, CharacterEntry>;
  visualAssets?: components["schemas"]["VisualAssets"] | undefined;
  onClose: () => void;
};

export function VisualNovelLogModal({
  segments,
  charactersMap,
  visualAssets,
  onClose,
}: VisualNovelLogModalProps): JSX.Element {
  const stopPropagation = (event: MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation();
  };

  return (
    <div onClick={stopPropagation}>
      <ModalFrame
        testId="visual-novel-log-modal"
        title="ログ"
        onClose={onClose}
      >
        {segments.length === 0 ? (
          <p className="text-pretty text-sm text-reader-muted">
            表示済みの文章はまだありません。
          </p>
        ) : (
          <div
            data-testid="visual-novel-log-scroll"
            className="max-h-[70dvh] overflow-y-auto overscroll-contain pr-1"
          >
            <div className="flex flex-col gap-4">
              {segments.map((segment, index) => (
                <SegmentRenderer
                  key={`${index}-${segment.type}`}
                  segment={segment}
                  charactersMap={charactersMap}
                  visualAssets={visualAssets}
                  variant="visualNovel"
                />
              ))}
            </div>
          </div>
        )}
      </ModalFrame>
    </div>
  );
}
